/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2
 */

export { SET_APP_LANGUAGE as dd }
export { UPDATE_EDIT_AREA as Qe }
export { a as Qj }
export { UPDATE_PREVIEW_AREA as Se }
export { c as Uj }
export { UPDATE_EXTENSION_WIDGET_LIST as Re }
export { updateExtensionWidgetListAction as Rj }
export { SHOW_COMMON_TOAST_INFO as re }
export { showCommonToastInfoAction as mj }
export { HIDE_COMMON_TOAST_INFO as pc }
export { h as kh }
export { SET_USER_INFO as he }
export { g as ej }
export { SET_FETCH_USER_INFO_DONE as nd }
export { v as hi }
export { ASYNC_SET_USER_INFO as wb }
export { asyncSetUserInfoAction as wg }
export { OPEN_CONFIRM_DIALOG as Ec }
export { openConfirmDialogAction as zh }
export { TOGGLE_PERMISSION_DIALOG as Ke }
export { togglePermissionDialogAction as Ej }
export { S as Vg }
export { OPEN_ICON_LIB_DIALOG as Fc }
export { CLOSE_ICON_LIB_DIALOG as Yb }
export { SHOW_IMPORT_FAIL_TOAST as Ae }
export { N as uj }
export { HIDE_IMPORT_FAIL_TOAST as xc }
export { k as rh }
export { CLOSE_PROJECT_DIALOG as Zb }
export { closeProjectDialogAction as Xg }
export { OPEN_PROJECT_DIALOG as Gc }
export { openProjectDialogAction as Ah }
export { SET_PROJECT_MODIFIED as Rd }
export { setProjectModifiedAction as Fi }
export { SET_PROJECT_LAST_SAVED_TIME as Qd }
export { G as Ei }
export { SET_PROJECT_SAVE_PROGRESS_DIALOG as Vd }
export { W as Qi }
export { SET_PROJECT_SAVE_PROGRESS as Ud }
export { V as Pi }
export { SET_PROJECT_SAVING as Xd }
export { Y as Si }
export { ASYNC_CANCEL_SAVE_PROJECT as y }
export { q as yf }
export { APPEND_MESSAGE_TO_CONSOLE as n }
export { appendMessageToConsoleAction as nf }
export { CLEAR_CONSOLE_MESSAGE as Tb }
export { J as Sg }
export { SET_CONSOLE_HEIGHT as kd }
export { ee as ei }
export { SHOW_STAGE_TOAST as De }
export { ne as xj }
export { HIDE_STAGE_TOAST as zc }
export { SET_ACTOR_DRAGGING as cd }
export { ae as Yh }
export { OPEN_SIGN_IN_DIALOG as Ic }
export { openSignInDialogAction as Ch }
export { CLOSE_SIGN_IN_DIALOG as bc }
export { ue as Zg }
export { SET_STAGE_RULER_VISIBLE as be }
export { pe as Wi }
export { SET_STAGE_VISIBLE as de }
export { he as Yi }
export { SET_IS_HOVER_BLOCK_AREA as Ad }
export { setIsHoverBlockAreaAction as ui }
export { setStageWidthAction as Zi }
export { SET_BLOCKY_TOOLBOX_PINED as gd }
export { ye as ci }
export { SET_WIDGET_ATTRIBUTE_VISIBLE as ie }
export { setWidgetAttributeVisibleAction as fj }
export { SET_RIGHT_SIDE_ACTIVE_MENU as ae }
export { Ce as Vi }
export { SHOW_GRID_DIALOG as ye }
export { Se as sj }
export { HIDE_GRID_DIALOG as wc }
export { Ae as qh }
export { SET_GRID_COPIED_CONTENT as td }
export { Ne as ni }
export { SET_GRID_SELECTED_CONTENT as xd }
export { ke as ri }
export { SET_GRID_EDITING_HEADER as ud }
export { De as oi }
export { SET_GRID_ERROR_HEADERS as wd }
export { Le as qi }
export { SET_GRID_ANIMATION_HEADERS as rd }
export { Be as li }
export { SET_GRID_ERROR_CELL as vd }
export { Ge as pi }
export { SET_GRID_COLUMN_CUSTOM_WIDTH as sd }
export { We as mi }
export { SET_STAGE_SCALE as ce }
export { SET_COLL_AUTO_SAVE as id }
export { Ye as di }
export { SET_HISTORY_ARCHIVE_ID as yd }
export { qe as si }
export { SET_PROJECT_EDIT_PERMISSION as Od }
export { Qe as Ci }
export { SHOW_HISTORY_DIALOG as ze }
export { Je as tj }
export { SET_WIDGET_MALL_VISIBLE as je }
export { et as gj }
export { ASYNC_INITIAL_MY_EXTENSION_WIDGETS as db }
export { nt as eg }
export { REPLACE_MY_EXTENSION_WIDGETS as Wc }
export { ot as Sh }
export { ADD_MY_EXTENSION_WIDGETS as g }
export { at as ef }
export { REMOVE_MY_EXTENSION_WIDGETS as Oc }
export { ct as Kh }
export { SET_BLOCK_IMAGE_DIALOG_INFO as hd }
export { ut as bi }
export { SHOW_RELEASE_INFO_DIALOG as Be }
export { ft as ne }
export { ht as ij }
export { SHOW_CLOUD_DB_MANAGER_DIALOG as oe }
export { gt as jj }
export { SHOW_CLOUD_DB_PUBLISH_DIALOG as pe }
export { vt as kj }
export { SET_IS_OFF_LINE as Bd }
export { setIsOffLineAction as vi }
export { TOGGLE_SLIDER_IMAGE_DIALOG as Me }
export { Ot as Gj }
export { TOGGLE_SWITCH_IMAGE_DIALOG as Ne }
export { Ct as Hj }
export { SHOW_TABLE_DATA_DIALOG as Ee }
export { St as zj }
export { HIDE_TABLE_DATA_DIALOG as Ac }
export { At as wh }
export { SHOW_CREATE_TABLE_DATA_DIALOG as te }
export { Nt as oj }
export { HIDE_CREATE_TABLE_DATA_DIALOG as rc }
export { kt as mh }
export { OPEN_RICH_TEXT_EDITOR_DIALOG as Hc }
export { Dt as Bh }
export { CLOSE_RICH_TEXT_EDITOR_DIALOG as ac }
export { Lt as Yg }
export { ASYNC_GET_TEMPLATE_LIST as W }
export { Bt as Xf }
export { SET_TEMPLATE_LIST as ge }
export { Gt as bj }
export { ASYNC_GET_COURSE_LIST as S }
export { Wt as Tf }
export { SET_COURSE_LIST as md }
export { Vt as gi }
export { SET_COURSE_DIALOG_VISIBLE as ld }
export { Yt as fi }
export { SET_PROJECT_SAVE_PROMPT as Wd }
export { qt as Ri }
export { Xt as fh }
export { ADD_FLOAT_ICON as d }
export { Zt as cf }
export { REMOVE_FLOAT_ICON as Mc }
export { $t as Gh }
export { REPLACE_FLOAT_ICON as Uc }
export { tn as Qh }
export { SET_FLOAT_ICON_VISIBLE_STATUS as od }
export { rn as ii }
export { SET_PROJECT_OPEN_FINISHED as Sd }
export { an as Gi }
export { promisify as Nf }
export { ASYNC_CREATE_PROJECT_SCREEN as H }
export { asyncCreateProjectScreenAction as Hf }
export { ASYNC_REMOVE_PROJECT_SCREEN as nb }
export { asyncRemoveProjectScreenAction as ng }
export { ASYNC_COPY_PROJECT_SCREEN as D }
export { fn as Df }
export { ASYNC_DELETE_PROJECT_WIDGET as M }
export { asyncDeleteProjectWidgetAction as Mf }
export { ASYNC_INSERT_PROJECT_WIDGET as gb }
export { _n as hg }
export { ASYNC_REGISTER_EXTENSION_WIDGET as lb }
export { bn as lg }
export { ASYNC_PACKAGE_PROJECT as jb }
export { En as jg }
export { SET_PACKAGING_PROJECT as Jd }
export { wn as Oi }
export { SET_PACKAGE_PROJECT_PROGRESS_VISIBLE as Hd }
export { Tn as Li }
export { SET_PACKAGE_PROGRESS_DIALOG_VISIBLE as Fd }
export { In as Ii }
export { SET_PACKAGE_QRCODE_DIALOG_VISIBLE as Id }
export { jn as Mi }
export { SET_PACKAGE_PROJECT_PROGRESS as Gd }
export { Rn as Ki }
export { ASYNC_UPDATE_PROJECT_PACKAGE_PROGRESS as Jb }
export { xn as Ig }
export { SET_PROJECT_PACKAGE_TASK_LABEL as Td }
export { Mn as Ni }
export { SET_PACKAGE_INFO as Ed }
export { Pn as Ji }
export { SET_COMPLETE_PACKAGE_DIALOG as jd }
export { Fn as Hi }
export { ASYNC_GET_PACKAGE_INFO as T }
export { Un as Vf }
export { ASYNC_CANCEL_PACKAGE as x }
export { Hn as xf }
export { ASYNC_EXPORT_PROJECT_AS_JSON as N }
export { zn as Of }
export { warpAsyncCreateProject as Gf }
export { ASYNC_CREATE_PLAYER_PROJECT as F }
export { Xn as Ff }
export { IMPORT_PROJECT_FROM_TO_DOC as Bc }
export { $n as xh }
export { ASYNC_PLAY_PROJECT as kb }
export { asyncPlayProjectAction as kg }
export { ASYNC_UPDATE_PROJECT_WIDGET_ATTRIBUTE as Lb }
export { rr as Kg }
export { ASYNC_UPDATE_PROJECT_WIDGET_TITLE as Ob }
export { ir as Ng }
export { ASYNC_UPDATE_PROJECT_WIDGET_IDS as Nb }
export { sr as Mg }
export { ASYNC_UPDATE_PROJECT_WIDGET_COMMON_ATTRIBUTE as Mb }
export { lr as Lg }
export { REPLACE_PROJECT as Xc }
export { dr as Th }
export { REPLACE_PROJECT_ID as Yc }
export { fr as Uh }
export { UPDATE_PROJECT_BCM_URL as Te }
export { mr as Vj }
export { DELETE_PROJECT_SCREEN as kc }
export { _r as eh }
export { ADD_PROJECT_SCREEN as k }
export { br as if }
export { UPDATE_PROJECT_SCREEN_TITLE as We }
export { Er as Yj }
export { UPDATE_PROJECT_SCREEN_COMMON_ATTRIBUTE as Ue }
export { wr as Wj }
export { ASYNC_UPDATE_PROJECT_SCREEN_COMMON_ATTRIBUTE as Kb }
export { Tr as Jg }
export { CHANGE_PROJECT_TITLE as Rb }
export { Ir as Qg }
export { ASYNC_CHANGE_PROJECT_TITLE as B }
export { jr as Bf }
export { UPDATE_PROJECT_SCREEN_SNAPSHOT as Ve }
export { updateProjectScreenSnapshotAction as Xj }
export { ADD_PROJECT_GLOBAL_WIDGET as j }
export { xr as hf }
export { ADD_PROJECT_WIDGET as l }
export { Mr as jf }
export { SORT_PROJECT_GLOBAL_WIDGET_IDS as Fe }
export { SORT_PROJECT_SCREEN_WIDGET_IDS as He }
export { Br as Bj }
export { REMOVE_PROJECT_GLOBAL_WIDGET as Pc }
export { Gr as Lh }
export { REMOVE_PROJECT_WIDGET as Qc }
export { Wr as Mh }
export { SELECT_PROJECT_WIDGET as bd }
export { Vr as Xh }
export { ASYNC_SELECT_PROJECT_WIDGET as ub }
export { asyncSelectProjectWidgetAction as ug }
export { SET_PROJECT_CURRENT_SCREEN_INDEX as Nd }
export { qr as Bi }
export { ASYNC_SET_PROJECT_CURRENT_SCREEN_INDEX as vb }
export { asyncSetProjectCurrentScreenIndexAction as vg }
export { START_PLAYING_PROJECT as Ie }
export { Jr as Cj }
export { STOP_PLAYING_PROJECT as Je }
export { stopPlayingProjectAction as Dj }
export { ASYNC_ADD_PRIMITIVE_VARIABLE as u }
export { no as uf }
export { ASYNC_ADD_ARRAY_VARIABLE as o }
export { oo as of }
export { ASYNC_DELETE_PRIMITIVE_VARIABLE as L }
export { ao as Lf }
export { ASYNC_DELETE_ARRAY_VARIABLE as I }
export { co as If }
export { ASYNC_ADD_OBJECT_VARIABLE as t }
export { uo as tf }
export { ADD_OBJECT_VARIABLE as h }
export { fo as ff }
export { DELETE_OBJECT_VARIABLE as ic }
export { mo as ch }
export { ASYNC_DELETE_OBJECT_VARIABLE as K }
export { _o as Kf }
export { SET_OBJECT_VARIABLE_NAME as Dd }
export { bo as xi }
export { SET_OBJECT_VARIABLE_DEFAULT_VALUE as Cd }
export { Eo as wi }
export { ASYNC_UPDATE_OBJECT_VARIABLE_PROPERTY as Gb }
export { wo as Gg }
export { MOVE_PROJECT_SCREEN as Dc }
export { moveProjectScreenAction as yh }
export { ADD_PRIMITIVE_VARIABLE as i }
export { Io as gf }
export { DELETE_PRIMITIVE_VARIABLE as jc }
export { jo as dh }
export { SET_PRIMITIVE_VARIABLE_NAME as Ld }
export { Ro as zi }
export { SET_PRIMITIVE_VARIABLE_DEFAULT_VALUE as Kd }
export { xo as yi }
export { ASYNC_UPDATE_PRIMITIVE_VARIABLE_PROPERTY as Hb }
export { Mo as Hg }
export { ASYNC_UPDATE_ARRAY_VARIABLE_PROPERTY as yb }
export { Po as yg }
export { ADD_ARRAY_VARIABLE as a }
export { Fo as Ye }
export { DELETE_ARRAY_VARIABLE as ec }
export { Uo as ah }
export { SET_ARRAY_VARIABLE_NAME as fd }
export { Ho as Zh }
export { SET_ARRAY_VARIABLE_DEFAULT_VALUE as ed }
export { zo as ai }
export { ADD_BROADCAST as b }
export { Ko as Ze }
export { DELETE_BROADCAST as fc }
export { ASYNC_ADD_BROADCAST as p }
export { Qo as pf }
export { CHANGE_CONTEXT_MENU_INFO as Pb }
export { changeContextMenuInfoAction as Og }
export { CLOSE_CONTEXT_MENU as Xb }
export { ASYNC_COPY_WIDGET_TO_SCREEN as E }
export { asyncCopyWidgetToScreenAction as Ef }
export { CLEAR_PROJECT as Vb }
export { oi as Ug }
export { ASYNC_INSERT_BRUSH_WIDGET as fb }
export { ai as gg }
export { ASYNC_INSERT_ACTOR_WIDGET as eb }
export { ci as fg }
export { CLOSE_STYLE_DIALOG as cc }
export { ui as vh }
export { OPEN_STYLE_DIALOG as Jc }
export { pi as Dh }
export { ASYNC_SAVE_PROJECT as tb }
export { asyncSaveProjectAction as tg }
export { ASYNC_LOCATE_BLOCK_POSITION as hb }
export { gi as ig }
export { ASYNC_UPDATE_PROJECT_API_TOKEN as Ib }
export { SET_PROJECT_API_TOKEN as Md }
export { bi as Ai }
export { SORT_PROJECT_SCREEN as Ge }
export { Ei as Aj }
export { SORT_SCREEN_BY_SCREEN_IDS as xb }
export { wi as xg }
export { SET_FOCUSED_WORKSPACE_AREA as qd }
export { Ti as ki }
export { ASYNC_INITIAL_CLOUD_DB_DATA as ab }
export { Ii as bg }
export { ASYNC_UPDATE_CLOUD_DATABASE_FIELDS as zb }
export { ji as Cg }
export { ASYNC_CHANGE_DATA_VIEWER_TEMPLATE as z }
export { Mi as Af }
export { ASYNC_RESET_DATA_VIEWER_BINDINGS as rb }
export { Pi as rg }
export { ASYNC_REVERT_HISTORY_VERSION as sb }
export { Fi as sg }
export { COLL_SET_DOC as dc }
export { ASYNC_INITIAL_CLOUD_DB_WIDGET as bb }
export { Wi as cg }
export { SET_PROJECT_SHARE_INFO as Yd }
export { Vi as Ti }
export { ASYNC_GET_PROJECT_SHARE_INFO as V }
export { Yi as Wf }
export { SET_PROJECT_JSON_FROM as Pd }
export { qi as Di }
export { SET_PROJECT_SOURCE as Zd }
export { Qi as Ui }
export { SHOW_BLOCKS_DROPDOWN as ke }
export { HIDE_BLOCKS_DROPDOWN as lc }
export { $i as gh }
export { SHOW_BLOCKS_SLIDER as le }
export { HIDE_BLOCKS_SLIDER as mc }
export { na as ih }
export { UPDATE_BLOCKS_SLIDER_VALUE as Oe }
export { SHOW_CREATE_DYNAMIC_DATA_DIALOG as se }
export { showCreateDynamicDataDialogAction as nj }
export { HIDE_CREATE_DYNAMIC_DATA_DIALOG as qc }
export { sa as lh }
export { SHOW_COMMON_INPUT_DIALOG as qe }
export { la as lj }
export { HIDE_COMMON_INPUT_DIALOG as oc }
export { da as jh }
export { SHOW_EDIT_ARRAY_DIALOG as we }
export { fa as qj }
export { HIDE_EDIT_ARRAY_DIALOG as uc }
export { ma as oh }
export { SHOW_EDIT_OBJECT_DIALOG as xe }
export { _a as rj }
export { HIDE_EDIT_OBJECT_DIALOG as vc }
export { ba as ph }
export { ASYNC_UPDATE_DOCUMENT_DATA as Fb }
export { Ea as Fg }
export { SHOW_DOCUMENT_DIALOG as ve }
export { wa as yj }
export { HIDE_DOCUMENT_DIALOG as tc }
export { Ta as uh }
export { ASYNC_OPEN_TOAST_ON_NOT_SELECT_DOCUMENT as ib }
export { Ia as af }
export { SHOW_BLOCK_PALETTE as me }
export { ja as hj }
export { HIDE_BLOCK_PALETTE as nc }
export { Ra as hh }
export { SET_FLYOUT_VISIBLE as pd }
export { xa as ji }
export { SET_IS_BLOCK_DRAG_DELETE_AREA as zd }
export { Ma as ti }
export { ASYNC_UPDATE_CLOUD_DB_DATA as Ab }
export { Pa as zg }
export { INIT_PROJECT_DATA_WATCH as Cc }
export { ADD_DATA_WATCH_VARIABLE as c }
export { Ga as bf }
export { UPDATE_DATA_WATCH_VARIABLE_PROPERTY as Pe }
export { updateDataWatchVariablePropertyAction as Pj }
export { DELETE_DATA_WATCH_VARIABLE as gc }
export { Va as bh }
export { RESET_DATA_WATCH_VALUE as ad }
export { resetDataWatchValueAction as Wh }
export { CLEAR_DATA_WATCH_VALUE as Ub }
export { qa as Tg }
export { SET_TABLE_DATA_WATCH_DIALOG as fe }
export { Qa as aj }
export { SHOW_DATAWATCH_TOAST as ue }
export { Ja as pj }
export { HIDE_DATAWATCH_TOAST as sc }
export { es as nh }
export { SHOW_RESOURCE_LIBRARY_DIALOG as Ce }
export { ns as wj }
export { HIDE_RESOURCE_LIBRARY_DIALOG as yc }
export { os as sh }
export { TOGGLE_RESOURCE_LIBRARY_DIALOG_VISIBLE as Le }
export { as as Fj }
export { UPDATE_RESOURCE_LIBRARY_AREA as Xe }
export { cs as Zj }
export { ASYNC_CHANGE_IMAGE_FILE_ID as A }
export { us as zf }
export { ASYNC_DELETE_IMAGE_FILE as J }
export { ps as Jf }
export { ASYNC_IMPORT_IMAGE_TO_IMAGE_WIDGET as X }
export { hs as Yf }
export { ASYNC_IMPORT_IMAGE_TO_RESOURCE_LIBRARY as Y }
export { gs as Zf }
export { ASYNC_ADD_IMAGE_FROM_RESOURCE as s }
export { vs as sf }
export { ADD_IMAGE_RESOURCE_LIBRARY as f }
export { DELETE_IMAGE_RESOURCE_LIBRARY as hc }
export { ASYNC_IMPORT_SOUND_TO_AUDIO_WIDGET as Z }
export { Os as ag }
export { ASYNC_ADD_SOUND_UPLOAD as w }
export { Cs as wf }
export { REPLACE_SOUND_RESOURCE as Zc }
export { Ss as Vh }
export { ADD_SOUND_STATE as m }
export { As as kf }
export { ASYNC_ADD_SOUND_FROM_RESOURCE as v }
export { Ns as vf }
export { REMOVE_SOUND_STATE as Rc }
export { ks as Nh }
export { ASYNC_REMOVE_SOUND as ob }
export { Ds as og }
export { RENAME_SOUND_STATE as Tc }
export { Ls as Ph }
export { ASYNC_RENAME_SOUND as qb }
export { Bs as qg }
export { CHANGE_SOUND_URL as Sb }
export { Gs as Rg }
export { ADD_ICON_STATE as e }
export { Ws as df }
export { ASYNC_ADD_ICON_FROM_RESOURCE as q }
export { Vs as qf }
export { ASYNC_ADD_ICON_FROM_UPLOAD as r }
export { Ys as rf }
export { ASYNC_REMOVE_ICON as mb }
export { qs as mg }
export { REMOVE_ICON_STATE as Nc }
export { Qs as Hh }
export { ASYNC_RENAME_ICON as pb }
export { Js as pg }
export { RENAME_ICON_STATE as Sc }
export { ec as Oh }
export { CHANGE_ICON_URL as Qb }
export { nc as Pg }
export { REPLACE_ICON_RESOURCE as Vc }
export { oc as Rh }
export { d as cj } from "../../../../unrestored/shared/1571/2636/37/343"
export { f as ak } from "../../../../unrestored/shared/1571/2636/37/343"
export { e as dj } from "../../../../unrestored/shared/1571/2636/37/343"
export { h as cb } from "../../../../unrestored/shared/1571/2636/162"
export { G as dg } from "../../../../unrestored/shared/1571/2636/162"
export { P as Kj } from "../../../../unrestored/shared/1571/2636/162"
export { Q as Lj } from "../../../../unrestored/shared/1571/2636/162"
export { e as P } from "../../../../unrestored/shared/1571/2636/162"
export { D as Qf } from "../../../../unrestored/shared/1571/2636/162"
export { U as Sj } from "../../../../unrestored/shared/1571/2636/162"
export { z as lf } from "../../../../unrestored/shared/1571/2636/162"
export { L as Ih } from "../../../../unrestored/shared/1571/2636/162"
export { V as Tj } from "../../../../unrestored/shared/1571/2636/162"
export { A as mf } from "../../../../unrestored/shared/1571/2636/162"
export { M as Jh } from "../../../../unrestored/shared/1571/2636/162"
export { c as C } from "../../../../unrestored/shared/1571/2636/162"
export { B as Cf } from "../../../../unrestored/shared/1571/2636/162"
export { N as Ij } from "../../../../unrestored/shared/1571/2636/162"
export { d as O } from "../../../../unrestored/shared/1571/2636/162"
export { C as Pf } from "../../../../unrestored/shared/1571/2636/162"
export { i as Bb } from "../../../../unrestored/shared/1571/2636/162"
export { H as Ag } from "../../../../unrestored/shared/1571/2636/162"
export { O as Jj } from "../../../../unrestored/shared/1571/2636/162"
export { R as Mj } from "../../../../unrestored/shared/1571/2636/162"
export { T as Oj } from "../../../../unrestored/shared/1571/2636/162"
export { f as Q } from "../../../../unrestored/shared/1571/2636/162"
export { E as Rf } from "../../../../unrestored/shared/1571/2636/162"
export { k as Db } from "../../../../unrestored/shared/1571/2636/162"
export { J as Dg } from "../../../../unrestored/shared/1571/2636/162"
export { g as R } from "../../../../unrestored/shared/1571/2636/162"
export { F as Sf } from "../../../../unrestored/shared/1571/2636/162"
export { S as Nj } from "../../../../unrestored/shared/1571/2636/162"
export { j as Cb } from "../../../../unrestored/shared/1571/2636/162"
export { I as Bg } from "../../../../unrestored/shared/1571/2636/162"
export { l as Eb } from "../../../../unrestored/shared/1571/2636/162"
export { K as Eg } from "../../../../unrestored/shared/1571/2636/162"

import * as /* [auto-meaningful-name] */Module_6 from /* 6 */"../../../../unrestored/shared/1571/2636/6"
import { ICommonToastInfo, IConfirmDialogInfo, IPermissionDialogInfo, IPluginDialog } from "./interface"

export const SET_APP_LANGUAGE = "SET_APP_LANGUAGE"

export const UPDATE_EDIT_AREA = "UPDATE_EDIT_AREA"
function a() {
  return {
    payload: undefined,
    type: UPDATE_EDIT_AREA
  }
}

export const UPDATE_PREVIEW_AREA = "UPDATE_PREVIEW_AREA"
function c() {
  return {
    payload: undefined,
    type: UPDATE_PREVIEW_AREA
  }
}

export const UPDATE_EXTENSION_WIDGET_LIST = "UPDATE_EXTENSION_WIDGET_LIST"
export function updateExtensionWidgetListAction() {
  return {
    payload: undefined,
    type: UPDATE_EXTENSION_WIDGET_LIST
  }
}

export const SHOW_COMMON_TOAST_INFO = "SHOW_COMMON_TOAST_INFO"
export function showCommonToastInfoAction(payload: ICommonToastInfo) {
  return {
    payload,
    type: SHOW_COMMON_TOAST_INFO
  }
}

export const HIDE_COMMON_TOAST_INFO = "HIDE_COMMON_TOAST_INFO"
function h() {
  return {
    payload: undefined,
    type: HIDE_COMMON_TOAST_INFO
  }
}

export const SET_USER_INFO = "SET_USER_INFO"
function g(e) {
  return {
    payload: e,
    type: SET_USER_INFO
  }
}

export const SET_FETCH_USER_INFO_DONE = "SET_FETCH_USER_INFO_DONE"
function v() {
  return {
    payload: true,
    type: SET_FETCH_USER_INFO_DONE
  }
}

export const ASYNC_SET_USER_INFO = "ASYNC_SET_USER_INFO"
export function asyncSetUserInfoAction(e) {
  return {
    payload: e,
    type: ASYNC_SET_USER_INFO
  }
}

export const OPEN_CONFIRM_DIALOG: string = "OPEN_CONFIRM_DIALOG"
export function openConfirmDialogAction(payload: IConfirmDialogInfo) {
  return {
    type: OPEN_CONFIRM_DIALOG,
    payload
  }
}

export const TOGGLE_PERMISSION_DIALOG = "TOGGLE_PERMISSION_DIALOG"
export function togglePermissionDialogAction(info: IPermissionDialogInfo) {
  return {
    type: TOGGLE_PERMISSION_DIALOG,
    payload: info
  }
}

export const CLOSE_CONFIRM_DIALOG = "CLOSE_CONFIRM_DIALOG"
function S() {
  return {
    type: CLOSE_CONFIRM_DIALOG,
    payload: undefined
  }
}

export const OPEN_ICON_LIB_DIALOG = "OPEN_ICON_LIB_DIALOG"

export const CLOSE_ICON_LIB_DIALOG = "CLOSE_ICON_LIB_DIALOG"

export const SHOW_IMPORT_FAIL_TOAST = "SHOW_IMPORT_FAIL_TOAST"
function N(e, t) {
  return {
    type: SHOW_IMPORT_FAIL_TOAST,
    payload: {
      importFailResults: e,
      fileType: t
    }
  }
}

export const HIDE_IMPORT_FAIL_TOAST = "HIDE_IMPORT_FAIL_TOAST"
function k() {
  return {
    type: HIDE_IMPORT_FAIL_TOAST,
    payload: undefined
  }
}

export const CLOSE_PROJECT_DIALOG = "CLOSE_PROJECT_DIALOG"
export function closeProjectDialogAction() {
  return {
    type: CLOSE_PROJECT_DIALOG,
    payload: undefined
  }
}

export const CLOSE_PLUGIN_DIALOG = "CLOSE_PLUGIN_DIALOG"
export function closePluginDialogAction() {
  return { type: CLOSE_PLUGIN_DIALOG, payload: undefined }
}

export const OPEN_PROJECT_DIALOG = "OPEN_PROJECT_DIALOG"
export function openProjectDialogAction(selected) {
  return {
    type: OPEN_PROJECT_DIALOG,
    payload: {
      selected
    }
  }
}

export const OPEN_PLUGIN_DIALOG = "OPEN_PLUGIN_DIALOG"
export function openPluginDialogAction() {
  return { type: OPEN_PLUGIN_DIALOG, payload: undefined }
}

export const SET_PROJECT_MODIFIED = "SET_PROJECT_MODIFIED"
export function setProjectModifiedAction(e) {
  return {
    payload: e,
    type: SET_PROJECT_MODIFIED
  }
}

export const SET_PROJECT_LAST_SAVED_TIME = "SET_PROJECT_LAST_SAVED_TIME"
function G(e) {
  return {
    type: SET_PROJECT_LAST_SAVED_TIME,
    payload: e
  }
}

export const SET_PROJECT_SAVE_PROGRESS_DIALOG = "SET_PROJECT_SAVE_PROGRESS_DIALOG"
function W(e) {
  return {
    payload: e,
    type: SET_PROJECT_SAVE_PROGRESS_DIALOG
  }
}

export const SET_PROJECT_SAVE_PROGRESS = "SET_PROJECT_SAVE_PROGRESS"
function V(e) {
  return {
    payload: e,
    type: SET_PROJECT_SAVE_PROGRESS
  }
}

export const SET_PROJECT_SAVING = "SET_PROJECT_SAVING"
function Y(e) {
  return {
    payload: e,
    type: SET_PROJECT_SAVING
  }
}

export const ASYNC_CANCEL_SAVE_PROJECT = "ASYNC_CANCEL_SAVE_PROJECT"
function q() {
  return {
    payload: undefined,
    type: ASYNC_CANCEL_SAVE_PROJECT
  }
}

export const APPEND_MESSAGE_TO_CONSOLE = "APPEND_MESSAGE_TO_CONSOLE"
export function appendMessageToConsoleAction(e) {
  return {
    type: APPEND_MESSAGE_TO_CONSOLE,
    payload: e
  }
}

export const CLEAR_CONSOLE_MESSAGE = "CLEAR_CONSOLE_MESSAGE"
function J() {
  return {
    type: CLEAR_CONSOLE_MESSAGE,
    payload: undefined
  }
}

export const SET_CONSOLE_HEIGHT = "SET_CONSOLE_HEIGHT"
function ee(e) {
  return {
    type: SET_CONSOLE_HEIGHT,
    payload: e
  }
}

export const SHOW_STAGE_TOAST = "SHOW_STAGE_TOAST"
function ne(e, t) {
  return {
    type: SHOW_STAGE_TOAST,
    payload: {
      toast: e,
      showIcon: t
    }
  }
}

export const HIDE_STAGE_TOAST = "HIDE_STAGE_TOAST"
export function hideStageToastAction() {
  return {
    type: HIDE_STAGE_TOAST,
    payload: undefined
  }
}

export const SET_ACTOR_DRAGGING = "SET_ACTOR_DRAGGING"
function ae(e) {
  return {
    type: SET_ACTOR_DRAGGING,
    payload: e
  }
}

export const OPEN_SIGN_IN_DIALOG = "OPEN_SIGN_IN_DIALOG"
export function openSignInDialogAction(onSuccess?: () => void) {
  return {
    type: OPEN_SIGN_IN_DIALOG,
    payload: {
      onSuccess
    }
  }
}

export const CLOSE_SIGN_IN_DIALOG = "CLOSE_SIGN_IN_DIALOG"
function ue() {
  return {
    type: CLOSE_SIGN_IN_DIALOG,
    payload: undefined
  }
}

export const SET_STAGE_RULER_VISIBLE = "SET_STAGE_RULER_VISIBLE"
function pe(e) {
  return {
    type: SET_STAGE_RULER_VISIBLE,
    payload: e
  }
}

export const SET_STAGE_VISIBLE = "SET_STAGE_VISIBLE"
function he(e) {
  return {
    type: SET_STAGE_VISIBLE,
    payload: e
  }
}

// [CoCo Next] 小屏设备可隐藏顶栏
export const SET_HEADER_VISIBLE = "SET_HEADER_VISIBLE"
export function setHeaderVisibleAction(headerVisible: boolean) {
  return {
    type: SET_HEADER_VISIBLE,
    payload: headerVisible
  }
}

// [CoCo Next] 小屏设备可隐藏屏幕列表
export const SET_SCREEN_LIST_VISIBLE = "SET_SCREEN_LIST_VISIBLE"
export function setScreenListVisibleAction(screenListVisible: boolean) {
  return {
    type: SET_SCREEN_LIST_VISIBLE,
    payload: screenListVisible
  }
}

export const SET_IS_HOVER_BLOCK_AREA = "SET_IS_HOVER_BLOCK_AREA"
export function setIsHoverBlockAreaAction(isHoverBlockArea: boolean) {
  return {
    type: SET_IS_HOVER_BLOCK_AREA,
    payload: isHoverBlockArea
  }
}

export const SET_STAGE_WIDTH = "SET_STAGE_WIDTH"
export function setStageWidthAction(stageWidth: number) {
  return {
    type: SET_STAGE_WIDTH,
    payload: stageWidth
  }
}

export const SET_BLOCKY_TOOLBOX_PINED = "SET_BLOCKY_TOOLBOX_PINED"
function ye(e) {
  return {
    type: SET_BLOCKY_TOOLBOX_PINED,
    payload: e
  }
}

export const SET_WIDGET_ATTRIBUTE_VISIBLE = "SET_WIDGET_ATTRIBUTE_VISIBLE"
export function setWidgetAttributeVisibleAction(widgetAttributeVisible: boolean) {
  return {
    type: SET_WIDGET_ATTRIBUTE_VISIBLE,
    payload: widgetAttributeVisible
  }
}

export const SET_RIGHT_SIDE_ACTIVE_MENU = "SET_RIGHT_SIDE_ACTIVE_MENU"
function Ce(e) {
  return {
    type: SET_RIGHT_SIDE_ACTIVE_MENU,
    payload: e
  }
}

export const SHOW_GRID_DIALOG = "SHOW_GRID_DIALOG"
function Se(e) {
  return {
    type: SHOW_GRID_DIALOG,
    payload: e
  }
}

export const HIDE_GRID_DIALOG = "HIDE_GRID_DIALOG"
function Ae() {
  return {
    type: HIDE_GRID_DIALOG,
    payload: undefined
  }
}

export const SET_GRID_COPIED_CONTENT = "SET_GRID_COPIED_CONTENT"
function Ne(e, t) {
  return {
    type: SET_GRID_COPIED_CONTENT,
    payload: {
      rowId: e,
      columnId: t
    }
  }
}

export const SET_GRID_SELECTED_CONTENT = "SET_GRID_SELECTED_CONTENT"
function ke(e, t) {
  return {
    type: SET_GRID_SELECTED_CONTENT,
    payload: {
      rowId: e,
      columnId: t
    }
  }
}

export const SET_GRID_EDITING_HEADER = "SET_GRID_EDITING_HEADER"
function De(e) {
  return {
    type: SET_GRID_EDITING_HEADER,
    payload: {
      columnId: e
    }
  }
}

export const SET_GRID_ERROR_HEADERS = "SET_GRID_ERROR_HEADERS"
function Le(e) {
  return {
    type: SET_GRID_ERROR_HEADERS,
    payload: {
      columnIds: e
    }
  }
}

export const SET_GRID_ANIMATION_HEADERS = "SET_GRID_ANIMATION_HEADERS"
function Be(e) {
  return {
    type: SET_GRID_ANIMATION_HEADERS,
    payload: {
      columnIds: e
    }
  }
}

export const SET_GRID_ERROR_CELL = "SET_GRID_ERROR_CELL"
function Ge(e) {
  return {
    type: SET_GRID_ERROR_CELL,
    payload: {
      errorCells: e
    }
  }
}

export const SET_GRID_COLUMN_CUSTOM_WIDTH = "SET_GRID_COLUMN_CUSTOM_WIDTH"
function We(e) {
  return {
    type: SET_GRID_COLUMN_CUSTOM_WIDTH,
    payload: e
  }
}

export const SET_STAGE_SCALE = "SET_STAGE_SCALE"
export function setStageScaleAction(e) {
  return {
    type: SET_STAGE_SCALE,
    payload: e
  }
}

export const SET_COLL_AUTO_SAVE = "SET_COLL_AUTO_SAVE"
function Ye(e) {
  return {
    type: SET_COLL_AUTO_SAVE,
    payload: e
  }
}

export const SET_HISTORY_ARCHIVE_ID = "SET_HISTORY_ARCHIVE_ID"
function qe(e) {
  return {
    type: SET_HISTORY_ARCHIVE_ID,
    payload: e
  }
}

export const SET_PROJECT_EDIT_PERMISSION = "SET_PROJECT_EDIT_PERMISSION"
function Qe(e) {
  return {
    type: SET_PROJECT_EDIT_PERMISSION,
    payload: e
  }
}

export const SHOW_HISTORY_DIALOG = "SHOW_HISTORY_DIALOG"
function Je(e) {
  return {
    type: SHOW_HISTORY_DIALOG,
    payload: e
  }
}

export const SET_WIDGET_MALL_VISIBLE = "SET_WIDGET_MALL_VISIBLE"
function et(e) {
  return {
    type: SET_WIDGET_MALL_VISIBLE,
    payload: e
  }
}

export const ASYNC_INITIAL_MY_EXTENSION_WIDGETS = "ASYNC_INITIAL_MY_EXTENSION_WIDGETS"
function nt() {
  return {
    type: ASYNC_INITIAL_MY_EXTENSION_WIDGETS,
    payload: undefined
  }
}

export const REPLACE_MY_EXTENSION_WIDGETS = "REPLACE_MY_EXTENSION_WIDGETS"
function ot(e) {
  return {
    type: REPLACE_MY_EXTENSION_WIDGETS,
    payload: {
      widgets: e
    }
  }
}

export const ADD_MY_EXTENSION_WIDGETS = "ADD_MY_EXTENSION_WIDGETS"
function at(e) {
  return {
    type: ADD_MY_EXTENSION_WIDGETS,
    payload: {
      widgets: e
    }
  }
}

export const REMOVE_MY_EXTENSION_WIDGETS = "REMOVE_MY_EXTENSION_WIDGETS"
function ct(e) {
  return {
    type: REMOVE_MY_EXTENSION_WIDGETS,
    payload: {
      widgetTypes: e
    }
  }
}

export const SET_BLOCK_IMAGE_DIALOG_INFO = "SET_BLOCK_IMAGE_DIALOG_INFO"
function ut(e, t) {
  return {
    type: SET_BLOCK_IMAGE_DIALOG_INFO,
    payload: {
      visible: e,
      imgSrc: t
    }
  }
}

export const SHOW_RELEASE_INFO_DIALOG = "SHOW_RELEASE_INFO_DIALOG"
export function showReleaseInfoDialog(visible: boolean) {
  return {
    type: SHOW_RELEASE_INFO_DIALOG,
    payload: visible
  }
}

var ft = ""
function ht(e, t, n, r, o) {
  return {
    type: ft,
    payload: {
      widgetName: e,
      visible: t,
      cloudDBId: n,
      isProd: r,
      callback: o
    }
  }
}

export const SHOW_CLOUD_DB_MANAGER_DIALOG = "SHOW_CLOUD_DB_MANAGER_DIALOG"
function gt(e) {
  return {
    type: SHOW_CLOUD_DB_MANAGER_DIALOG,
    payload: e
  }
}

export const SHOW_CLOUD_DB_PUBLISH_DIALOG = "SHOW_CLOUD_DB_PUBLISH_DIALOG"
function vt(e, t, callback) {
  return {
    type: SHOW_CLOUD_DB_PUBLISH_DIALOG,
    payload: {
      visible: e,
      type: t,
      callback
    }
  }
}

export const SET_IS_OFF_LINE = "SET_IS_OFF_LINE"
export function setIsOffLineAction(isOffline: boolean) {
  return {
    type: SET_IS_OFF_LINE,
    payload: isOffline
  }
}

export const TOGGLE_SLIDER_IMAGE_DIALOG = "TOGGLE_SLIDER_IMAGE_DIALOG"
function Ot(e) {
  return {
    type: TOGGLE_SLIDER_IMAGE_DIALOG,
    payload: e
  }
}

export const TOGGLE_SWITCH_IMAGE_DIALOG = "TOGGLE_SWITCH_IMAGE_DIALOG"
function Ct(e) {
  return {
    type: TOGGLE_SWITCH_IMAGE_DIALOG,
    payload: e
  }
}

export const SHOW_TABLE_DATA_DIALOG = "SHOW_TABLE_DATA_DIALOG"
function St(e) {
  return {
    type: SHOW_TABLE_DATA_DIALOG,
    payload: e
  }
}

export const HIDE_TABLE_DATA_DIALOG = "HIDE_TABLE_DATA_DIALOG"
function At() {
  return {
    type: HIDE_TABLE_DATA_DIALOG,
    payload: undefined
  }
}

export const SHOW_CREATE_TABLE_DATA_DIALOG = "SHOW_CREATE_TABLE_DATA_DIALOG"
function Nt(e) {
  return {
    type: SHOW_CREATE_TABLE_DATA_DIALOG,
    payload: e
  }
}

export const HIDE_CREATE_TABLE_DATA_DIALOG = "HIDE_CREATE_TABLE_DATA_DIALOG"
function kt() {
  return {
    type: HIDE_CREATE_TABLE_DATA_DIALOG,
    payload: undefined
  }
}

export const OPEN_RICH_TEXT_EDITOR_DIALOG = "OPEN_RICH_TEXT_EDITOR_DIALOG"
function Dt(e) {
  return {
    type: OPEN_RICH_TEXT_EDITOR_DIALOG,
    payload: e
  }
}

export const CLOSE_RICH_TEXT_EDITOR_DIALOG = "CLOSE_RICH_TEXT_EDITOR_DIALOG"
function Lt() {
  return {
    type: CLOSE_RICH_TEXT_EDITOR_DIALOG,
    payload: undefined
  }
}

export const ASYNC_GET_TEMPLATE_LIST = "ASYNC_GET_TEMPLATE_LIST"
function Bt() {
  return {
    payload: undefined,
    type: ASYNC_GET_TEMPLATE_LIST
  }
}

export const SET_TEMPLATE_LIST = "SET_TEMPLATE_LIST"
function Gt(e) {
  return {
    payload: e,
    type: SET_TEMPLATE_LIST
  }
}

export const ASYNC_GET_COURSE_LIST = "ASYNC_GET_COURSE_LIST"
function Wt() {
  return {
    payload: undefined,
    type: ASYNC_GET_COURSE_LIST
  }
}

export const SET_COURSE_LIST = "SET_COURSE_LIST"
function Vt(e) {
  return {
    payload: e,
    type: SET_COURSE_LIST
  }
}

export const SET_COURSE_DIALOG_VISIBLE = "SET_COURSE_DIALOG_VISIBLE"
function Yt(e) {
  return {
    payload: e,
    type: SET_COURSE_DIALOG_VISIBLE
  }
}

export const SET_PROJECT_SAVE_PROMPT = "SET_PROJECT_SAVE_PROMPT"
function qt(e) {
  return {
    payload: e,
    type: SET_PROJECT_SAVE_PROMPT
  }
}
var Xt = {
  withClose: false,
  visible: true
}

export const ADD_FLOAT_ICON = "ADD_FLOAT_ICON"
function Zt(e) {
  return {
    payload: Module_6.a(Module_6.a({}, Xt), e),
    type: ADD_FLOAT_ICON
  }
}

export const REMOVE_FLOAT_ICON = "REMOVE_FLOAT_ICON"
function $t(e) {
  return {
    payload: e,
    type: REMOVE_FLOAT_ICON
  }
}

export const REPLACE_FLOAT_ICON = "REPLACE_FLOAT_ICON"
function tn(e, t) {
  return {
    payload: {
      name: e,
      icon: Module_6.a(Module_6.a({}, Xt), t)
    },
    type: REPLACE_FLOAT_ICON
  }
}

export const SET_FLOAT_ICON_VISIBLE_STATUS = "SET_FLOAT_ICON_VISIBLE_STATUS"
function rn(e, t) {
  return {
    payload: {
      name: e,
      visible: t
    },
    type: SET_FLOAT_ICON_VISIBLE_STATUS
  }
}

export const SET_PROJECT_OPEN_FINISHED = "SET_PROJECT_OPEN_FINISHED"
function an(e) {
  return {
    payload: e,
    type: SET_PROJECT_OPEN_FINISHED
  }
}

export function promisify<T = unknown>(
  func: (payload: {}) => void,
  payload: {}
): Promise<T> {
  return new Promise((resolve, reject) => {
    const newPayload = {
      ...payload,
      resolve,
      reject
    }
    func(newPayload)
  })
}

export const ASYNC_CREATE_PROJECT_SCREEN = "ASYNC_CREATE_PROJECT_SCREEN"
export function asyncCreateProjectScreenAction(index?: number) {
  return {
    payload: { index },
    type: ASYNC_CREATE_PROJECT_SCREEN
  }
}

export const ASYNC_REMOVE_PROJECT_SCREEN = "ASYNC_REMOVE_PROJECT_SCREEN"
export function asyncRemoveProjectScreenAction(screenId: string, isEmitOT?: boolean) {
  return {
    type: ASYNC_REMOVE_PROJECT_SCREEN,
    payload: { screenId, isEmitOT }
  }
}

export const ASYNC_COPY_PROJECT_SCREEN = "ASYNC_COPY_PROJECT_SCREEN"
function fn(e) {
  return {
    type: ASYNC_COPY_PROJECT_SCREEN,
    payload: {
      screenId: e
    }
  }
}

export const ASYNC_DELETE_PROJECT_WIDGET = "ASYNC_DELETE_PROJECT_WIDGET"
export function asyncDeleteProjectWidgetAction(widgetId, screenId, isEmitOT?) {
  return {
    payload: { screenId, widgetId, isEmitOT },
    type: ASYNC_DELETE_PROJECT_WIDGET
  }
}

export const ASYNC_INSERT_PROJECT_WIDGET = "ASYNC_INSERT_PROJECT_WIDGET"
function _n(e, t, n, r, o) {
  return {
    payload: {
      screenId: e,
      widgetType: t,
      position: n,
      attributes: r,
      setBlockValue: o
    },
    type: ASYNC_INSERT_PROJECT_WIDGET
  }
}

export const ASYNC_REGISTER_EXTENSION_WIDGET = "ASYNC_REGISTER_EXTENSION_WIDGET"
function bn(e) {
  return {
    type: ASYNC_REGISTER_EXTENSION_WIDGET,
    payload: {
      widgetType: e
    }
  }
}

export const ASYNC_PACKAGE_PROJECT = "ASYNC_PACKAGE_PROJECT"
function En() {
  return {
    payload: undefined,
    type: ASYNC_PACKAGE_PROJECT
  }
}

export const SET_PACKAGING_PROJECT = "SET_PACKAGING_PROJECT"
function wn(e, t) {
  return {
    payload: {
      isPackaging: e,
      packageUrl: t
    },
    type: SET_PACKAGING_PROJECT
  }
}

export const SET_PACKAGE_PROJECT_PROGRESS_VISIBLE = "SET_PACKAGE_PROJECT_PROGRESS_VISIBLE"
function Tn(e) {
  return {
    payload: {
      packageProgressVisible: e
    },
    type: SET_PACKAGE_PROJECT_PROGRESS_VISIBLE
  }
}

export const SET_PACKAGE_PROGRESS_DIALOG_VISIBLE = "SET_PACKAGE_PROGRESS_DIALOG_VISIBLE"
function In(e) {
  return {
    payload: {
      packageDialogVisible: e
    },
    type: SET_PACKAGE_PROGRESS_DIALOG_VISIBLE
  }
}

export const SET_PACKAGE_QRCODE_DIALOG_VISIBLE = "SET_PACKAGE_QRCODE_DIALOG_VISIBLE"
function jn(e) {
  return {
    payload: {
      packageQrCodeVisible: e
    },
    type: SET_PACKAGE_QRCODE_DIALOG_VISIBLE
  }
}

export const SET_PACKAGE_PROJECT_PROGRESS = "SET_PACKAGE_PROJECT_PROGRESS"
function Rn(e) {
  return {
    payload: {
      packageProgress: e
    },
    type: SET_PACKAGE_PROJECT_PROGRESS
  }
}

export const ASYNC_UPDATE_PROJECT_PACKAGE_PROGRESS = "ASYNC_UPDATE_PROJECT_PACKAGE_PROGRESS"
function xn() {
  return {
    type: ASYNC_UPDATE_PROJECT_PACKAGE_PROGRESS,
    payload: null
  }
}

export const SET_PROJECT_PACKAGE_TASK_LABEL = "SET_PROJECT_PACKAGE_TASK_LABEL"
function Mn(e) {
  return {
    type: SET_PROJECT_PACKAGE_TASK_LABEL,
    payload: {
      label: e
    }
  }
}

export const SET_PACKAGE_INFO = "SET_PACKAGE_INFO"
function Pn(e) {
  return {
    payload: e,
    type: SET_PACKAGE_INFO
  }
}

export const SET_COMPLETE_PACKAGE_DIALOG = "SET_COMPLETE_PACKAGE_DIALOG"
function Fn(e) {
  return {
    payload: {
      packageCompleteVisible: e
    },
    type: SET_COMPLETE_PACKAGE_DIALOG
  }
}

export const ASYNC_GET_PACKAGE_INFO = "ASYNC_GET_PACKAGE_INFO"
function Un() {
  return {
    payload: null,
    type: ASYNC_GET_PACKAGE_INFO
  }
}

export const ASYNC_CANCEL_PACKAGE = "ASYNC_CANCEL_PACKAGE"
function Hn() {
  return {
    payload: null,
    type: ASYNC_CANCEL_PACKAGE
  }
}

export const ASYNC_EXPORT_PROJECT_AS_JSON = "ASYNC_EXPORT_PROJECT_AS_JSON"
function zn(e) {
  return {
    payload: {
      shouldCloneCloud: e
    },
    type: ASYNC_EXPORT_PROJECT_AS_JSON
  }
}

export const ASYNC_CREATE_PROJECT = "ASYNC_CREATE_PROJECT"
export { ASYNC_CREATE_PROJECT as G }
export function warpAsyncCreateProject({
  json,
  jsonFrom,
  lastSavedTime,
  isAuthor,
  isCollWork,
  projectId,
  editPermission,
  sourceTag,
  sourceId
} = {}) {
  return {
    payload: {
      json,
      jsonFrom,
      lastSavedTime,
      isAuthor,
      isCollWork,
      projectId,
      editPermission,
      sourceTag,
      sourceId
    },
    type: ASYNC_CREATE_PROJECT
  }
}

export const ASYNC_CREATE_PLAYER_PROJECT = "ASYNC_CREATE_PLAYER_PROJECT"
function Xn(e) {
  return {
    payload: {
      json: e
    },
    type: ASYNC_CREATE_PLAYER_PROJECT
  }
}

export const ASYNC_GET_PROJECT_ERROR = "ASYNC_GET_PROJECT_ERROR"
export function asyncGetProjectErrorAction(data) {
  return {
    payload: {
      code: data.code
    },
    type: ASYNC_GET_PROJECT_ERROR
  }
}

export const IMPORT_PROJECT_FROM_TO_DOC = "IMPORT_PROJECT_FROM_TO_DOC"
function $n(e) {
  return {
    type: IMPORT_PROJECT_FROM_TO_DOC,
    payload: {
      json: e
    }
  }
}

export const ASYNC_PLAY_PROJECT = "ASYNC_PLAY_PROJECT"
export function asyncPlayProjectAction(e) {
  return {
    payload: {
      isPlayCurrentScreen: e
    },
    type: ASYNC_PLAY_PROJECT
  }
}

export const ASYNC_UPDATE_PROJECT_WIDGET_ATTRIBUTE = "ASYNC_UPDATE_PROJECT_WIDGET_ATTRIBUTE"
function rr(e, t, n) {
  return {
    payload: {
      widgetId: e,
      key: t,
      value: n
    },
    type: ASYNC_UPDATE_PROJECT_WIDGET_ATTRIBUTE
  }
}

export const ASYNC_UPDATE_PROJECT_WIDGET_TITLE = "ASYNC_UPDATE_PROJECT_WIDGET_TITLE"
function ir(e, t, n, r, o) {
  return {
    payload: {
      widgetId: e,
      title: t,
      shouldUpdatePreviewArea: n,
      shouldUpdateEditArea: r,
      isEmitOT: o
    },
    type: ASYNC_UPDATE_PROJECT_WIDGET_TITLE
  }
}

export const ASYNC_UPDATE_PROJECT_WIDGET_IDS = "ASYNC_UPDATE_PROJECT_WIDGET_IDS"
function sr(screenId, widgetId, widgetIds, shouldUpdatePreviewArea, shouldUpdateEditArea, isEmitOT) {
  return {
    payload: {
      screenId,
      widgetId,
      widgetIds,
      shouldUpdatePreviewArea,
      shouldUpdateEditArea,
      isEmitOT
    },
    type: ASYNC_UPDATE_PROJECT_WIDGET_IDS
  }
}

export const ASYNC_UPDATE_PROJECT_WIDGET_COMMON_ATTRIBUTE = "ASYNC_UPDATE_PROJECT_WIDGET_COMMON_ATTRIBUTE"
function lr(e, t, n, r, o, i, a) {
  return {
    payload: {
      widgetId: e,
      key: t,
      value: n,
      shouldUpdatePreviewArea: r,
      shouldUpdateEditArea: o,
      isEmitOT: i,
      isBasePropertyPriority: a
    },
    type: ASYNC_UPDATE_PROJECT_WIDGET_COMMON_ATTRIBUTE
  }
}

export const REPLACE_PROJECT = "REPLACE_PROJECT"
function dr(e) {
  return {
    type: REPLACE_PROJECT,
    payload: {
      project: e
    }
  }
}

export const REPLACE_PROJECT_ID = "REPLACE_PROJECT_ID"
function fr(e) {
  return {
    type: REPLACE_PROJECT_ID,
    payload: {
      projectId: e
    }
  }
}

export const UPDATE_PROJECT_BCM_URL = "UPDATE_PROJECT_BCM_URL"
function mr(e) {
  return {
    type: UPDATE_PROJECT_BCM_URL,
    payload: {
      bcmUrl: e
    }
  }
}

export const DELETE_PROJECT_SCREEN = "DELETE_PROJECT_SCREEN"
function _r(e) {
  return {
    payload: {
      screenId: e
    },
    type: DELETE_PROJECT_SCREEN
  }
}

export const ADD_PROJECT_SCREEN = "ADD_PROJECT_SCREEN"
function br(e, t) {
  return {
    payload: {
      screen: e,
      index: t
    },
    type: ADD_PROJECT_SCREEN
  }
}

export const UPDATE_PROJECT_SCREEN_TITLE = "UPDATE_PROJECT_SCREEN_TITLE"
function Er(e, t) {
  return {
    type: UPDATE_PROJECT_SCREEN_TITLE,
    payload: {
      screenId: e,
      title: t
    }
  }
}

export const UPDATE_PROJECT_SCREEN_COMMON_ATTRIBUTE = "UPDATE_PROJECT_SCREEN_COMMON_ATTRIBUTE"
function wr(e, t, n) {
  return {
    type: UPDATE_PROJECT_SCREEN_COMMON_ATTRIBUTE,
    payload: {
      screenId: e,
      key: t,
      value: n
    }
  }
}

export const ASYNC_UPDATE_PROJECT_SCREEN_COMMON_ATTRIBUTE = "ASYNC_UPDATE_PROJECT_SCREEN_COMMON_ATTRIBUTE"
function Tr(e, t, n, r) {
  return {
    type: ASYNC_UPDATE_PROJECT_SCREEN_COMMON_ATTRIBUTE,
    payload: {
      screenId: e,
      key: t,
      value: n,
      isEmitOT: r
    }
  }
}

export const CHANGE_PROJECT_TITLE = "CHANGE_PROJECT_TITLE"
function Ir(e) {
  return {
    type: CHANGE_PROJECT_TITLE,
    payload: {
      title: e
    }
  }
}

export const ASYNC_CHANGE_PROJECT_TITLE = "ASYNC_CHANGE_PROJECT_TITLE"
function jr(e, t) {
  return {
    type: ASYNC_CHANGE_PROJECT_TITLE,
    payload: {
      title: e,
      isEmitOT: t
    }
  }
}

export const UPDATE_PROJECT_SCREEN_SNAPSHOT = "UPDATE_PROJECT_SCREEN_SNAPSHOT"
export function updateProjectScreenSnapshotAction(e, t) {
  return {
    type: UPDATE_PROJECT_SCREEN_SNAPSHOT,
    payload: {
      screenId: e,
      snapshot: t
    }
  }
}

export const ADD_PROJECT_GLOBAL_WIDGET = "ADD_PROJECT_GLOBAL_WIDGET"
function xr(e) {
  return {
    payload: {
      widgetId: e
    },
    type: ADD_PROJECT_GLOBAL_WIDGET
  }
}

export const ADD_PROJECT_WIDGET = "ADD_PROJECT_WIDGET"
function Mr(e, t, n) {
  return {
    payload: {
      screenId: e,
      widgetId: t,
      isInvisibleWidget: n
    },
    type: ADD_PROJECT_WIDGET
  }
}

export const SORT_PROJECT_GLOBAL_WIDGET_IDS = "SORT_PROJECT_GLOBAL_WIDGET_IDS"

export const SORT_PROJECT_SCREEN_WIDGET_IDS = "SORT_PROJECT_SCREEN_WIDGET_IDS"
function Br(e, t, n) {
  return {
    type: SORT_PROJECT_SCREEN_WIDGET_IDS,
    payload: {
      widgetIds: t,
      screenId: e,
      isInvisibleWidget: n
    }
  }
}

export const REMOVE_PROJECT_GLOBAL_WIDGET = "REMOVE_PROJECT_GLOBAL_WIDGET"
function Gr(e) {
  return {
    payload: {
      widgetId: e
    },
    type: REMOVE_PROJECT_GLOBAL_WIDGET
  }
}

export const REMOVE_PROJECT_WIDGET = "REMOVE_PROJECT_WIDGET"
function Wr(e, t, n) {
  return {
    payload: {
      screenId: e,
      widgetId: t,
      isInvisibleWidget: n
    },
    type: REMOVE_PROJECT_WIDGET
  }
}

export const SELECT_PROJECT_WIDGET = "SELECT_PROJECT_WIDGET"
function Vr(e) {
  return {
    payload: {
      widgetId: e
    },
    type: SELECT_PROJECT_WIDGET
  }
}

export const ASYNC_SELECT_PROJECT_WIDGET = "ASYNC_SELECT_PROJECT_WIDGET"
export function asyncSelectProjectWidgetAction(widgetId: string, isEmitOT?: boolean) {
  return {
    payload: {
      widgetId: widgetId,
      isEmitOT: isEmitOT
    },
    type: ASYNC_SELECT_PROJECT_WIDGET
  }
}

export const SET_PROJECT_CURRENT_SCREEN_INDEX = "SET_PROJECT_CURRENT_SCREEN_INDEX"
function qr(e) {
  return {
    payload: e,
    type: SET_PROJECT_CURRENT_SCREEN_INDEX
  }
}

export const ASYNC_SET_PROJECT_CURRENT_SCREEN_INDEX = "ASYNC_SET_PROJECT_CURRENT_SCREEN_INDEX"
export function asyncSetProjectCurrentScreenIndexAction(index: number, shouldSaveCurrentData?: boolean) {
  return {
    payload: { index, shouldSaveCurrentData },
    type: ASYNC_SET_PROJECT_CURRENT_SCREEN_INDEX
  }
}

export const START_PLAYING_PROJECT = "START_PLAYING_PROJECT"
function Jr() {
  return {
    payload: undefined,
    type: START_PLAYING_PROJECT
  }
}

export const STOP_PLAYING_PROJECT = "STOP_PLAYING_PROJECT"
export function stopPlayingProjectAction() {
  return {
    payload: undefined,
    type: STOP_PLAYING_PROJECT
  }
}

export const ASYNC_ADD_PRIMITIVE_VARIABLE = "ASYNC_ADD_PRIMITIVE_VARIABLE"
function no(e, t, n, r, o, i, a, s) {
  return {
    payload: {
      variableType: e,
      id: t,
      name: n,
      defaultValue: r,
      screenId: o,
      index: i,
      setBlockValue: a,
      isEmitOT: s
    },
    type: ASYNC_ADD_PRIMITIVE_VARIABLE
  }
}

export const ASYNC_ADD_ARRAY_VARIABLE = "ASYNC_ADD_ARRAY_VARIABLE"
function oo(e, t, n, r, o, i, a, s) {
  return {
    payload: {
      arrayType: e,
      id: t,
      name: n,
      defaultValue: r,
      screenId: o,
      setBlockValue: a,
      isEmitOT: s,
      index: i
    },
    type: ASYNC_ADD_ARRAY_VARIABLE
  }
}

export const ASYNC_DELETE_PRIMITIVE_VARIABLE = "ASYNC_DELETE_PRIMITIVE_VARIABLE"
function ao(e, t, n, r) {
  return {
    payload: {
      variableType: e,
      id: t,
      screenId: n,
      isEmitOT: r
    },
    type: ASYNC_DELETE_PRIMITIVE_VARIABLE
  }
}

export const ASYNC_DELETE_ARRAY_VARIABLE = "ASYNC_DELETE_ARRAY_VARIABLE"
function co(e, t, n, r) {
  return {
    payload: {
      arrayType: e,
      id: t,
      screenId: n,
      isEmitOT: r
    },
    type: ASYNC_DELETE_ARRAY_VARIABLE
  }
}

export const ASYNC_ADD_OBJECT_VARIABLE = "ASYNC_ADD_OBJECT_VARIABLE"
function uo(e) {
  return {
    payload: e,
    type: ASYNC_ADD_OBJECT_VARIABLE
  }
}

export const ADD_OBJECT_VARIABLE = "ADD_OBJECT_VARIABLE"
function fo(e) {
  return {
    payload: e,
    type: ADD_OBJECT_VARIABLE
  }
}

export const DELETE_OBJECT_VARIABLE = "DELETE_OBJECT_VARIABLE"
function mo(e, t, n) {
  return {
    payload: {
      scopeType: e,
      id: t,
      screenId: n
    },
    type: DELETE_OBJECT_VARIABLE
  }
}

export const ASYNC_DELETE_OBJECT_VARIABLE = "ASYNC_DELETE_OBJECT_VARIABLE"
function _o(e, t, n, r) {
  return {
    payload: {
      scopeType: e,
      id: t,
      screenId: n,
      isEmitOT: r
    },
    type: ASYNC_DELETE_OBJECT_VARIABLE
  }
}

export const SET_OBJECT_VARIABLE_NAME = "SET_OBJECT_VARIABLE_NAME"
function bo(e, t, n, r) {
  return {
    payload: {
      scopeType: e,
      id: t,
      name: n,
      screenId: r
    },
    type: SET_OBJECT_VARIABLE_NAME
  }
}

export const SET_OBJECT_VARIABLE_DEFAULT_VALUE = "SET_OBJECT_VARIABLE_DEFAULT_VALUE"
function Eo(e, t, n, r) {
  return {
    payload: {
      scopeType: e,
      id: t,
      defaultValue: n,
      screenId: r
    },
    type: SET_OBJECT_VARIABLE_DEFAULT_VALUE
  }
}

export const ASYNC_UPDATE_OBJECT_VARIABLE_PROPERTY = "ASYNC_UPDATE_OBJECT_VARIABLE_PROPERTY"
function wo(e) {
  return {
    type: ASYNC_UPDATE_OBJECT_VARIABLE_PROPERTY,
    payload: e
  }
}

export const MOVE_PROJECT_SCREEN = "MOVE_PROJECT_SCREEN"
export function moveProjectScreenAction(from: number, to: number) {
  return {
    type: MOVE_PROJECT_SCREEN,
    payload: { from, to }
  }
}

export const ADD_PRIMITIVE_VARIABLE = "ADD_PRIMITIVE_VARIABLE"
function Io(e, t, n, r, o, i) {
  return {
    payload: {
      variableType: e,
      id: t,
      name: n,
      defaultValue: r,
      screenId: o,
      index: i
    },
    type: ADD_PRIMITIVE_VARIABLE
  }
}

export const DELETE_PRIMITIVE_VARIABLE = "DELETE_PRIMITIVE_VARIABLE"
function jo(e, t, n) {
  return {
    payload: {
      variableType: e,
      id: t,
      screenId: n
    },
    type: DELETE_PRIMITIVE_VARIABLE
  }
}

export const SET_PRIMITIVE_VARIABLE_NAME = "SET_PRIMITIVE_VARIABLE_NAME"
function Ro(e, t, n, r) {
  return {
    payload: {
      variableType: e,
      id: t,
      name: n,
      screenId: r
    },
    type: SET_PRIMITIVE_VARIABLE_NAME
  }
}

export const SET_PRIMITIVE_VARIABLE_DEFAULT_VALUE = "SET_PRIMITIVE_VARIABLE_DEFAULT_VALUE"
function xo(e, t, n, r) {
  return {
    payload: {
      variableType: e,
      id: t,
      defaultValue: n,
      screenId: r
    },
    type: SET_PRIMITIVE_VARIABLE_DEFAULT_VALUE
  }
}

export const ASYNC_UPDATE_PRIMITIVE_VARIABLE_PROPERTY = "ASYNC_UPDATE_PRIMITIVE_VARIABLE_PROPERTY"
function Mo(e, t, n, r, o, i) {
  return {
    type: ASYNC_UPDATE_PRIMITIVE_VARIABLE_PROPERTY,
    payload: {
      variableType: e,
      id: t,
      key: n,
      value: r,
      screenId: o,
      isEmitOT: i
    }
  }
}

export const ASYNC_UPDATE_ARRAY_VARIABLE_PROPERTY = "ASYNC_UPDATE_ARRAY_VARIABLE_PROPERTY"
function Po(e, t, n, r, o, i) {
  return {
    type: ASYNC_UPDATE_ARRAY_VARIABLE_PROPERTY,
    payload: {
      arrayType: e,
      id: t,
      key: n,
      value: r,
      screenId: o,
      isEmitOT: i
    }
  }
}

export const ADD_ARRAY_VARIABLE = "ADD_ARRAY_VARIABLE"
function Fo(e, t, n, r, o, i) {
  return {
    payload: {
      arrayType: e,
      id: t,
      name: n,
      defaultValue: r,
      screenId: o,
      index: i
    },
    type: ADD_ARRAY_VARIABLE
  }
}

export const DELETE_ARRAY_VARIABLE = "DELETE_ARRAY_VARIABLE"
function Uo(e, t, n) {
  return {
    payload: {
      arrayType: e,
      id: t,
      screenId: n
    },
    type: DELETE_ARRAY_VARIABLE
  }
}

export const SET_ARRAY_VARIABLE_NAME = "SET_ARRAY_VARIABLE_NAME"
function Ho(e, t, n, r) {
  return {
    payload: {
      arrayType: e,
      id: t,
      name: n,
      screenId: r
    },
    type: SET_ARRAY_VARIABLE_NAME
  }
}

export const SET_ARRAY_VARIABLE_DEFAULT_VALUE = "SET_ARRAY_VARIABLE_DEFAULT_VALUE"
function zo(e, t, n, r) {
  return {
    payload: {
      arrayType: e,
      id: t,
      defaultValue: n,
      screenId: r
    },
    type: SET_ARRAY_VARIABLE_DEFAULT_VALUE
  }
}

export const ADD_BROADCAST = "ADD_BROADCAST"
function Ko(e, t, n) {
  return {
    payload: {
      name: e,
      screenId: t,
      index: n
    },
    type: ADD_BROADCAST
  }
}

export const DELETE_BROADCAST = "DELETE_BROADCAST"

export const ASYNC_ADD_BROADCAST = "ASYNC_ADD_BROADCAST"
function Qo(e, t, n, r, o) {
  return {
    payload: {
      name: e,
      screenId: t,
      setBlockValue: r,
      index: n,
      isEmitOT: o
    },
    type: ASYNC_ADD_BROADCAST
  }
}

export const CHANGE_CONTEXT_MENU_INFO = "CHANGE_CONTEXT_MENU_INFO"
export function changeContextMenuInfoAction(e) {
  return {
    payload: e,
    type: CHANGE_CONTEXT_MENU_INFO
  }
}

export const CLOSE_CONTEXT_MENU = "CLOSE_CONTEXT_MENU"
export function closeContextMenuAction() {
  return {
    type: CLOSE_CONTEXT_MENU,
    payload: undefined
  }
}

export const ASYNC_COPY_WIDGET_TO_SCREEN = "ASYNC_COPY_WIDGET_TO_SCREEN"
export function asyncCopyWidgetToScreenAction(widgetCloneList, screenId?) {
  return {
    type: ASYNC_COPY_WIDGET_TO_SCREEN,
    payload: { widgetCloneList, screenId }
  }
}

export const CLEAR_PROJECT = "CLEAR_PROJECT"
function oi() {
  return {
    type: CLEAR_PROJECT,
    payload: undefined
  }
}

export const ASYNC_INSERT_BRUSH_WIDGET = "ASYNC_INSERT_BRUSH_WIDGET"
function ai(e, t) {
  return {
    type: ASYNC_INSERT_BRUSH_WIDGET,
    payload: {
      widgetId: e,
      position: t
    }
  }
}

export const ASYNC_INSERT_ACTOR_WIDGET = "ASYNC_INSERT_ACTOR_WIDGET"
function ci(e, t) {
  return {
    type: ASYNC_INSERT_ACTOR_WIDGET,
    payload: {
      widgetId: e,
      position: t
    }
  }
}

export const CLOSE_STYLE_DIALOG = "CLOSE_STYLE_DIALOG"
function ui() {
  return {
    type: CLOSE_STYLE_DIALOG
  }
}

export const OPEN_STYLE_DIALOG = "OPEN_STYLE_DIALOG"
function pi(e, t) {
  return {
    type: OPEN_STYLE_DIALOG,
    payload: {
      actorId: e,
      onSelect: t
    }
  }
}

export const ASYNC_SAVE_PROJECT = "ASYNC_SAVE_PROJECT"
export function asyncSaveProjectAction({
  isUpdate, isAutoSave, isNeedReport, isSaveAs
}: {
  isUpdate: boolean
  isAutoSave: boolean
  isNeedReport?: boolean
  isSaveAs?: boolean
}) {
  return {
    payload: {
      isUpdate,
      isAutoSave,
      isNeedReport,
      isSaveAs
    },
    type: ASYNC_SAVE_PROJECT
  }
}

export const ASYNC_LOCATE_BLOCK_POSITION = "ASYNC_LOCATE_BLOCK_POSITION"
function gi(e, t) {
  return {
    type: ASYNC_LOCATE_BLOCK_POSITION,
    payload: {
      blockId: e,
      screenId: t
    }
  }
}

export const ASYNC_UPDATE_PROJECT_API_TOKEN = "ASYNC_UPDATE_PROJECT_API_TOKEN"

export const SET_PROJECT_API_TOKEN = "SET_PROJECT_API_TOKEN"
function bi(e) {
  return {
    type: SET_PROJECT_API_TOKEN,
    payload: {
      token: e
    }
  }
}

export const SORT_PROJECT_SCREEN = "SORT_PROJECT_SCREEN"
function Ei(e) {
  return {
    type: SORT_PROJECT_SCREEN,
    payload: {
      screens: e
    }
  }
}

export const SORT_SCREEN_BY_SCREEN_IDS = "SORT_SCREEN_BY_SCREEN_IDS"
function wi(e) {
  return {
    type: SORT_SCREEN_BY_SCREEN_IDS,
    payload: {
      screenIds: e
    }
  }
}

export const SET_FOCUSED_WORKSPACE_AREA = "SET_FOCUSED_WORKSPACE_AREA"
function Ti(e) {
  return {
    type: SET_FOCUSED_WORKSPACE_AREA,
    payload: {
      area: e
    }
  }
}

export const ASYNC_INITIAL_CLOUD_DB_DATA = "ASYNC_INITIAL_CLOUD_DB_DATA"
function Ii() {
  return {
    type: ASYNC_INITIAL_CLOUD_DB_DATA,
    payload: undefined
  }
}

export const ASYNC_UPDATE_CLOUD_DATABASE_FIELDS = "ASYNC_UPDATE_CLOUD_DATABASE_FIELDS"
function ji(e, t, n) {
  return {
    type: ASYNC_UPDATE_CLOUD_DATABASE_FIELDS,
    payload: {
      widgetId: e,
      fields: t,
      setBlockValue: n
    }
  }
}

export const PUBLISH_WORK_TO_COMMUNITY = "PUBLISH_WORK_TO_COMMUNITY"
export function publishWorkToCommunityAction(
  name: string,
  description: string,
  operation: string,
  coverUrl: string
) {
  return {
    type: PUBLISH_WORK_TO_COMMUNITY,
    payload: { name, description, operation, coverUrl }
  }
}

export const PUBLISH_WORK_TO_H5 = "PUBLISH_WORK_TO_H5"
export function publishWorkToH5Action(info) {
  return {
    type: PUBLISH_WORK_TO_H5,
    payload: { info }
  }
}

export const ASYNC_CHANGE_DATA_VIEWER_TEMPLATE = "ASYNC_CHANGE_DATA_VIEWER_TEMPLATE"
function Mi(e, t, n) {
  return {
    type: ASYNC_CHANGE_DATA_VIEWER_TEMPLATE,
    payload: {
      widgetId: e,
      templateType: t,
      onSuccess: n
    }
  }
}

export const ASYNC_RESET_DATA_VIEWER_BINDINGS = "ASYNC_RESET_DATA_VIEWER_BINDINGS"
function Pi(e, t) {
  return {
    type: ASYNC_RESET_DATA_VIEWER_BINDINGS,
    payload: {
      gridId: e,
      deleteColumnIdList: t
    }
  }
}

export const ASYNC_REVERT_HISTORY_VERSION = "ASYNC_REVERT_HISTORY_VERSION"
function Fi(e) {
  return {
    type: ASYNC_REVERT_HISTORY_VERSION,
    payload: {
      archiveId: e
    }
  }
}

export const COLL_SET_DOC = "COLL_SET_DOC"

export const ASYNC_INITIAL_CLOUD_DB_WIDGET = "ASYNC_INITIAL_CLOUD_DB_WIDGET"
function Wi() {
  return {
    type: ASYNC_INITIAL_CLOUD_DB_WIDGET,
    payload: undefined
  }
}

export const SET_PROJECT_SHARE_INFO = "SET_PROJECT_SHARE_INFO"
function Vi(e) {
  return {
    payload: e,
    type: SET_PROJECT_SHARE_INFO
  }
}

export const ASYNC_GET_PROJECT_SHARE_INFO = "ASYNC_GET_PROJECT_SHARE_INFO"
function Yi(e) {
  return {
    payload: {
      callback: e
    },
    type: ASYNC_GET_PROJECT_SHARE_INFO
  }
}

export const SET_PROJECT_JSON_FROM = "SET_PROJECT_JSON_FROM"
function qi(e) {
  return {
    type: SET_PROJECT_JSON_FROM,
    payload: e
  }
}

export const SET_PROJECT_SOURCE = "SET_PROJECT_SOURCE"
function Qi(e) {
  return {
    type: SET_PROJECT_SOURCE,
    payload: e
  }
}

export const SHOW_BLOCKS_DROPDOWN = "SHOW_BLOCKS_DROPDOWN"

export const HIDE_BLOCKS_DROPDOWN = "HIDE_BLOCKS_DROPDOWN"
function $i() {
  return {
    payload: undefined,
    type: HIDE_BLOCKS_DROPDOWN
  }
}

export const SHOW_BLOCKS_SLIDER = "SHOW_BLOCKS_SLIDER"

export const HIDE_BLOCKS_SLIDER = "HIDE_BLOCKS_SLIDER"
function na() {
  return {
    payload: undefined,
    type: HIDE_BLOCKS_SLIDER
  }
}

export const UPDATE_BLOCKS_SLIDER_VALUE = "UPDATE_BLOCKS_SLIDER_VALUE"

export const SHOW_CREATE_DYNAMIC_DATA_DIALOG = "SHOW_CREATE_DYNAMIC_DATA_DIALOG"
export function showCreateDynamicDataDialogAction(e) {
  return {
    payload: e,
    type: SHOW_CREATE_DYNAMIC_DATA_DIALOG
  }
}

export const HIDE_CREATE_DYNAMIC_DATA_DIALOG = "HIDE_CREATE_DYNAMIC_DATA_DIALOG"
function sa() {
  return {
    payload: undefined,
    type: HIDE_CREATE_DYNAMIC_DATA_DIALOG
  }
}

export const SHOW_COMMON_INPUT_DIALOG = "SHOW_COMMON_INPUT_DIALOG"
function la(e) {
  return {
    payload: e,
    type: SHOW_COMMON_INPUT_DIALOG
  }
}

export const HIDE_COMMON_INPUT_DIALOG = "HIDE_COMMON_INPUT_DIALOG"
function da() {
  return {
    payload: undefined,
    type: HIDE_COMMON_INPUT_DIALOG
  }
}

export const SHOW_EDIT_ARRAY_DIALOG = "SHOW_EDIT_ARRAY_DIALOG"
function fa(e) {
  return {
    payload: e,
    type: SHOW_EDIT_ARRAY_DIALOG
  }
}

export const HIDE_EDIT_ARRAY_DIALOG = "HIDE_EDIT_ARRAY_DIALOG"
function ma() {
  return {
    payload: undefined,
    type: HIDE_EDIT_ARRAY_DIALOG
  }
}

export const SHOW_EDIT_OBJECT_DIALOG = "SHOW_EDIT_OBJECT_DIALOG"
function _a(e) {
  return {
    payload: e,
    type: SHOW_EDIT_OBJECT_DIALOG
  }
}

export const HIDE_EDIT_OBJECT_DIALOG = "HIDE_EDIT_OBJECT_DIALOG"
function ba() {
  return {
    payload: undefined,
    type: HIDE_EDIT_OBJECT_DIALOG
  }
}

export const ASYNC_UPDATE_DOCUMENT_DATA = "ASYNC_UPDATE_DOCUMENT_DATA"
function Ea(e, t, n) {
  return {
    type: ASYNC_UPDATE_DOCUMENT_DATA,
    payload: {
      id: e,
      fields: t,
      isEmitOT: n
    }
  }
}

export const SHOW_DOCUMENT_DIALOG = "SHOW_DOCUMENT_DIALOG"
function wa(e) {
  return {
    type: SHOW_DOCUMENT_DIALOG,
    payload: e
  }
}

export const HIDE_DOCUMENT_DIALOG = "HIDE_DOCUMENT_DIALOG"
function Ta() {
  return {
    type: HIDE_DOCUMENT_DIALOG,
    payload: undefined
  }
}

export const ASYNC_OPEN_TOAST_ON_NOT_SELECT_DOCUMENT = "ASYNC_OPEN_TOAST_ON_NOT_SELECT_DOCUMENT"
function Ia(e, t) {
  return {
    type: "CLOUD_DATABASE",
    payload: {
      name: t,
      id: e
    }
  }
}

export const SHOW_BLOCK_PALETTE = "SHOW_BLOCK_PALETTE"
function ja(e) {
  return {
    type: SHOW_BLOCK_PALETTE,
    payload: e
  }
}

export const HIDE_BLOCK_PALETTE = "HIDE_BLOCK_PALETTE"
function Ra() {
  return {
    type: HIDE_BLOCK_PALETTE,
    payload: undefined
  }
}

export const SET_FLYOUT_VISIBLE = "SET_FLYOUT_VISIBLE"
function xa(e) {
  return {
    payload: e,
    type: SET_FLYOUT_VISIBLE
  }
}

export const SET_IS_BLOCK_DRAG_DELETE_AREA = "SET_IS_BLOCK_DRAG_DELETE_AREA"
function Ma(e) {
  return {
    payload: e,
    type: SET_IS_BLOCK_DRAG_DELETE_AREA
  }
}

export const ASYNC_UPDATE_CLOUD_DB_DATA = "ASYNC_UPDATE_CLOUD_DB_DATA"
function Pa(e, t, n) {
  return {
    type: ASYNC_UPDATE_CLOUD_DB_DATA,
    payload: {
      id: e,
      columns: t,
      isEmitOT: n
    }
  }
}

export const INIT_PROJECT_DATA_WATCH = "INIT_PROJECT_DATA_WATCH"

export const ADD_DATA_WATCH_VARIABLE = "ADD_DATA_WATCH_VARIABLE"
function Ga(e) {
  return {
    payload: e,
    type: ADD_DATA_WATCH_VARIABLE
  }
}

export const UPDATE_DATA_WATCH_VARIABLE_PROPERTY = "UPDATE_DATA_WATCH_VARIABLE_PROPERTY"
export function updateDataWatchVariablePropertyAction(id: string, property: string, value: unknown) {
  return {
    payload: { id, property, value },
    type: UPDATE_DATA_WATCH_VARIABLE_PROPERTY
  }
}

export const DELETE_DATA_WATCH_VARIABLE = "DELETE_DATA_WATCH_VARIABLE"
function Va(e) {
  return {
    payload: e,
    type: DELETE_DATA_WATCH_VARIABLE
  }
}

export const RESET_DATA_WATCH_VALUE = "RESET_DATA_WATCH_VALUE"
export function resetDataWatchValueAction() {
  return {
    type: RESET_DATA_WATCH_VALUE,
    payload: undefined
  }
}

export const CLEAR_DATA_WATCH_VALUE = "CLEAR_DATA_WATCH_VALUE"
function qa() {
  var e = arguments.length > 0 && undefined !== arguments[0] && arguments[0]
  return {
    type: CLEAR_DATA_WATCH_VALUE,
    payload: e
  }
}

export const SET_TABLE_DATA_WATCH_DIALOG = "SET_TABLE_DATA_WATCH_DIALOG"
function Qa(e, t) {
  return {
    type: SET_TABLE_DATA_WATCH_DIALOG,
    payload: {
      visible: e,
      id: t
    }
  }
}

export const SHOW_DATAWATCH_TOAST = "SHOW_DATAWATCH_TOAST"
function Ja(e, t) {
  return {
    type: SHOW_DATAWATCH_TOAST,
    payload: {
      toast: e,
      showIcon: t
    }
  }
}

export const HIDE_DATAWATCH_TOAST = "HIDE_DATAWATCH_TOAST"
function es() {
  return {
    type: HIDE_DATAWATCH_TOAST,
    payload: undefined
  }
}

export const SHOW_RESOURCE_LIBRARY_DIALOG = "SHOW_RESOURCE_LIBRARY_DIALOG"
function ns(e, t, n, r, o) {
  return {
    type: SHOW_RESOURCE_LIBRARY_DIALOG,
    payload: {
      mode: e,
      onSelect: t,
      multiple: n,
      sidebarType: r,
      setTab: o
    }
  }
}

export const HIDE_RESOURCE_LIBRARY_DIALOG = "HIDE_RESOURCE_LIBRARY_DIALOG"
function os() {
  return {
    type: HIDE_RESOURCE_LIBRARY_DIALOG,
    payload: undefined
  }
}

export const TOGGLE_RESOURCE_LIBRARY_DIALOG_VISIBLE = "TOGGLE_RESOURCE_LIBRARY_DIALOG_VISIBLE"
function as(e) {
  return {
    type: TOGGLE_RESOURCE_LIBRARY_DIALOG_VISIBLE,
    payload: {
      visible: e
    }
  }
}

export const UPDATE_RESOURCE_LIBRARY_AREA = "UPDATE_RESOURCE_LIBRARY_AREA"
function cs() {
  return {
    payload: undefined,
    type: UPDATE_RESOURCE_LIBRARY_AREA
  }
}

export const ASYNC_CHANGE_IMAGE_FILE_ID = "ASYNC_CHANGE_IMAGE_FILE_ID"
function us(e, t, n) {
  return {
    type: ASYNC_CHANGE_IMAGE_FILE_ID,
    payload: {
      newId: e,
      oldId: t,
      isEmitOT: n
    }
  }
}

export const ASYNC_DELETE_IMAGE_FILE = "ASYNC_DELETE_IMAGE_FILE"
function ps(e, t) {
  return {
    type: ASYNC_DELETE_IMAGE_FILE,
    payload: {
      imageFileId: e,
      isEmitOT: t
    }
  }
}

export const ASYNC_IMPORT_IMAGE_TO_IMAGE_WIDGET = "ASYNC_IMPORT_IMAGE_TO_IMAGE_WIDGET"
function hs(e, t) {
  return {
    type: ASYNC_IMPORT_IMAGE_TO_IMAGE_WIDGET,
    payload: {
      imageFile: e,
      widgetId: t
    }
  }
}

export const ASYNC_IMPORT_IMAGE_TO_RESOURCE_LIBRARY = "ASYNC_IMPORT_IMAGE_TO_RESOURCE_LIBRARY"
function gs(e, t, n) {
  return {
    type: ASYNC_IMPORT_IMAGE_TO_RESOURCE_LIBRARY,
    payload: {
      fileList: e,
      onSuccess: t,
      isMultipleFiles: n
    }
  }
}

export const ASYNC_ADD_IMAGE_FROM_RESOURCE = "ASYNC_ADD_IMAGE_FROM_RESOURCE"
function vs(e, t) {
  return {
    type: ASYNC_ADD_IMAGE_FROM_RESOURCE,
    payload: {
      imageFiles: e,
      isEmitOT: t
    }
  }
}

export const ADD_IMAGE_RESOURCE_LIBRARY = "ADD_IMAGE_RESOURCE_LIBRARY"

export const DELETE_IMAGE_RESOURCE_LIBRARY = "DELETE_IMAGE_RESOURCE_LIBRARY"

export const ASYNC_IMPORT_SOUND_TO_AUDIO_WIDGET = "ASYNC_IMPORT_SOUND_TO_AUDIO_WIDGET"
function Os(e, t) {
  return {
    type: ASYNC_IMPORT_SOUND_TO_AUDIO_WIDGET,
    payload: {
      soundFile: e,
      widgetId: t
    }
  }
}

export const ASYNC_ADD_SOUND_UPLOAD = "ASYNC_ADD_SOUND_UPLOAD"
function Cs(e, t, n) {
  return {
    type: ASYNC_ADD_SOUND_UPLOAD,
    payload: {
      fileList: e,
      onSuccess: t,
      isMultipleFiles: n
    }
  }
}

export const REPLACE_SOUND_RESOURCE = "REPLACE_SOUND_RESOURCE"
function Ss(e) {
  return {
    payload: {
      soundFileList: e
    },
    type: REPLACE_SOUND_RESOURCE
  }
}

export const ADD_SOUND_STATE = "ADD_SOUND_STATE"
function As(e, t) {
  return {
    payload: {
      soundFiles: e,
      index: t
    },
    type: ADD_SOUND_STATE
  }
}

export const ASYNC_ADD_SOUND_FROM_RESOURCE = "ASYNC_ADD_SOUND_FROM_RESOURCE"
function Ns(e, t) {
  return {
    payload: {
      soundFiles: e,
      isEmitOT: t
    },
    type: ASYNC_ADD_SOUND_FROM_RESOURCE
  }
}

export const REMOVE_SOUND_STATE = "REMOVE_SOUND_STATE"
function ks(e) {
  return {
    payload: {
      id: e
    },
    type: REMOVE_SOUND_STATE
  }
}

export const ASYNC_REMOVE_SOUND = "ASYNC_REMOVE_SOUND"
function Ds(e, t) {
  return {
    payload: {
      id: e,
      isEmitOT: t
    },
    type: ASYNC_REMOVE_SOUND
  }
}

export const RENAME_SOUND_STATE = "RENAME_SOUND_STATE"
function Ls(e, t) {
  return {
    payload: {
      id: e,
      name: t
    },
    type: RENAME_SOUND_STATE
  }
}

export const ASYNC_RENAME_SOUND = "ASYNC_RENAME_SOUND"
function Bs(e, t, n, r) {
  return {
    payload: {
      id: e,
      oldName: t,
      newName: n,
      isEmitOT: r
    },
    type: ASYNC_RENAME_SOUND
  }
}

export const CHANGE_SOUND_URL = "CHANGE_SOUND_URL"
function Gs(e, t) {
  return {
    type: CHANGE_SOUND_URL,
    payload: {
      id: e,
      cdnUrl: t
    }
  }
}

export const ADD_ICON_STATE = "ADD_ICON_STATE"
function Ws(e, t) {
  return {
    payload: {
      iconFiles: e,
      index: t
    },
    type: ADD_ICON_STATE
  }
}

export const ASYNC_ADD_ICON_FROM_RESOURCE = "ASYNC_ADD_ICON_FROM_RESOURCE"
function Vs(e, t) {
  return {
    payload: {
      iconFiles: e,
      isEmitOT: t
    },
    type: ASYNC_ADD_ICON_FROM_RESOURCE
  }
}

export const ASYNC_ADD_ICON_FROM_UPLOAD = "ASYNC_ADD_ICON_FROM_UPLOAD"
function Ys(e, t) {
  return {
    payload: {
      fileList: e,
      onSuccess: t
    },
    type: ASYNC_ADD_ICON_FROM_UPLOAD
  }
}

export const ASYNC_REMOVE_ICON = "ASYNC_REMOVE_ICON"
function qs(e, t) {
  return {
    payload: {
      id: e,
      isEmitOT: t
    },
    type: ASYNC_REMOVE_ICON
  }
}

export const REMOVE_ICON_STATE = "REMOVE_ICON_STATE"
function Qs(e) {
  return {
    payload: {
      id: e
    },
    type: REMOVE_ICON_STATE
  }
}

export const ASYNC_RENAME_ICON = "ASYNC_RENAME_ICON"
function Js(e, t, n, r) {
  return {
    payload: {
      id: e,
      oldName: t,
      newName: n,
      isEmitOT: r
    },
    type: ASYNC_RENAME_ICON
  }
}

export const RENAME_ICON_STATE = "RENAME_ICON_STATE"
function ec(e, t) {
  return {
    payload: {
      id: e,
      name: t
    },
    type: RENAME_ICON_STATE
  }
}

export const CHANGE_ICON_URL = "CHANGE_ICON_URL"
function nc(e, t) {
  return {
    type: CHANGE_ICON_URL,
    payload: {
      id: e,
      cdnUrl: t
    }
  }
}

export const REPLACE_ICON_RESOURCE = "REPLACE_ICON_RESOURCE"
function oc(e) {
  return {
    payload: {
      iconFileList: e
    },
    type: REPLACE_ICON_RESOURCE
  }
}

// 提取运行位置设置
export const SET_START_CURRENT_SCREEN = "SET_START_CURRENT_SCREEN"
export function setStartCurrentScreenAction(startCurrentScreen: boolean) {
  return {
    payload: startCurrentScreen,
    type: SET_START_CURRENT_SCREEN
  }
}
